import apiClient from './apiClient';

export const listCourseCategories = () => apiClient.get('/course-categories');

export const createCourseCategory = (body) => apiClient.post('/course-categories', body);

export const updateCourseCategory = (id, body) => apiClient.put(`/course-categories/${id}`, body);

export const deleteCourseCategory = (id) => apiClient.delete(`/course-categories/${id}`);
